import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { AfePanel } from "./AfePanel";

/**
 * AFE Management screen (§11) — the standalone route. Resolves the current
 * well's active event and renders the program-step sequence + AFE line grid
 * with accrual methods. Role-restricted in intent (cost engineer / AFE
 * approver plan; a service company self-serves its own lines); the panel scopes
 * what each role sees + edits.
 */
export function AfeManagement() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("afe.title")}</h1>
        <p className="subtitle">
          {well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}
        </p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? <AfePanel eventId={activeEvent.id} /> : null}
      </QueryState>
    </div>
  );
}
